<template>
  <v-list class="d-flex flex-column pb-3">
    <CountryListItem
      v-for="country in COUNTRIES_IN_ORDER"
      :key="country"
      :country="country"
      :href="getAppUrlByCountry(country)"
      :append-icon="getIcon(country)"
    />
  </v-list>
</template>

<script setup lang="ts">
import CountryListItem from './CountryListItem.vue'
import { COUNTRY_CODE, type CountryCode, getAppUrlByCountry } from '@/core/i18n'

type Props = {
  showSelected?: boolean
}

const props = defineProps<Props>()

const COUNTRIES_IN_ORDER = [
  COUNTRY_CODE.RU,
  COUNTRY_CODE.AM,
  COUNTRY_CODE.BY,
  COUNTRY_CODE.GE,
  COUNTRY_CODE.KZ,
  COUNTRY_CODE.KG,
  COUNTRY_CODE.MD,
  COUNTRY_CODE.TJ,
  COUNTRY_CODE.UZ,
]

const locale = useAppLocale()

function getIcon(country: CountryCode) {
  if (!props.showSelected) {
    return {
      icon: 'ui-icon-arrow-right',
      color: 'ui-kit-icon-secondary',
    }
  }

  return locale.currentCountry && locale.currentCountry === country
    ? {
      icon: 'ui-icon-check',
      color: 'primary',
    }
    : null
}
</script>
